import { render, staticRenderFns } from "./ModalTransCreate.vue?vue&type=template&id=98530e4e&"
import script from "./ModalTransCreate.vue?vue&type=script&lang=js&"
export * from "./ModalTransCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports